import { BaseLogo, LogoType } from "../../../core/models/entities/BaseLogo";

/**
 * Determines if a logo can be cloned based on type, transfer method and color flags.
 */
export function shouldAllowCloning(logo: BaseLogo): boolean {
  if (logo.logoType !== LogoType.ImageLogo) {
    return false;
  }

  const transferType = logo.transferMethod.type.toLowerCase();
  if (transferType === "broderi" || transferType === "embroidery") {
    return false;
  }

  const hasRestrictedPantone = logo.colorDetails?.some(
    (color) => color.isBlocker || color.isIndigo || color.isSublimation
  );

  if (hasRestrictedPantone) {
    return false;
  }

  const transferMethodRestricted = logo.transferMethod.isSublimation;

  return !transferMethodRestricted;
}
